import api from '@/lib/api';
import type {
  ApiResponse,
  UserPreferences,
  UpdatePreferencesRequest,
} from '@amuster/types';

export const preferencesService = {
  getPreferences() {
    return api.get<ApiResponse<UserPreferences>>('/auth/preferences');
  },

  updatePreferences(data: UpdatePreferencesRequest) {
    return api.put<ApiResponse<UserPreferences>>('/auth/preferences', data);
  },
};
